module.exports = __webpack_public_path__ + "img/age-history.51447efd.png";